import { css } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const text = css`
  margin-bottom: 16px;
  text-align: center;

  ${above["m"]} {
    text-align: left;
  }
`

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;

  ${above["l"]} {
    flex-direction: row;
    gap: 32px;
    margin-bottom: 56px;
  }

  .iq-text {
    ${text}
  }
`
export const image = css`
  display: flex;
  justify-content: center;
`
export const figure = css`
  object-fit: contain;
  object-position: left;
  width: 215px;
  height: 136px;

  ${above["m"]} {
    width: 265px;
    height: 170px;
  }
`
export const data = css`
  flex-grow: 1;
`

export const benefitsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding-top: 16px;

  ${above["m"]} {
    gap: 16px;
  }
`
export const benefit = css`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: space-between;

  .cp-text--body-medium {
    text-align: right;
  }

  ${above["m"]} {
    justify-content: flex-start;
    gap: 8px;
  }
`
export const label = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: ${colorsCP["emerald-50"]};
`
